import { sendRegisterRequestToFramework, sendRequestToFramework, sendNotificationToFramework, ofLogger } from '../HelperFunctions';
import { OPERATIONS } from '../models/Operations';
import { IAudioDeviceOperation, IAudioState } from '../models/AudioDevice';

/**
 * Fetch the complete audio state from the uniquely registered audio provider.
 */
export function getAudioState(): Promise<IAudioState> {
  return sendRequestToFramework(OPERATIONS.GET_AUDIO_STATE, []).then((resolved) => resolved);
}

/**
 * Register to answer the framework's request for current state.
 */
export function registerGetAudioState(callback: () => Promise<IAudioState> | IAudioState): Promise<void> {
  return sendRegisterRequestToFramework(() => Promise.resolve().then(() => callback()), OPERATIONS.GET_AUDIO_STATE);
}

/**
 * Broadcast the complete audio state whenever hardware or active assignment changes.
 */
export function setAudioState(state: IAudioState): void {
  sendNotificationToFramework(OPERATIONS.AUDIO_STATE_UPDATED, [state]);
}

/**
 * Subscribe to live broadcast updates of the audio state.
 */
export function registerAudioStateUpdated(callback: (stateByApp: { [appName: string]: IAudioState }) => void): Promise<void> {
  return sendRegisterRequestToFramework((...params: any[]): any => {
    callback(params[0] || {});
    return undefined;  
  }, OPERATIONS.AUDIO_STATE_UPDATED);
}

/** Send an apply or save operation to the uniquely registered audio provider. */
export function setAudioDeviceForApp(operation: IAudioDeviceOperation): Promise<void> {
  return sendRequestToFramework(OPERATIONS.AUDIO_DEVICE_SELECTED, [{ ...operation, source: 'UI' }]).then(() => {});
}

/**
 * Register to execute hardware switch when commanded by UI.
 */
export function registerSetAudioDevice(callback: (operation: IAudioDeviceOperation) => Promise<void>): Promise<void> {
  return sendRegisterRequestToFramework(
  operation => Promise.resolve().then(() => callback(operation)),
  OPERATIONS.AUDIO_DEVICE_SELECTED
  );
}
